'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _semanticUiReact = require('semantic-ui-react');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DyzioSearchBox = function (_React$Component) {
  (0, _inherits3.default)(DyzioSearchBox, _React$Component);

  function DyzioSearchBox(props) {
    (0, _classCallCheck3.default)(this, DyzioSearchBox);

    var _this = (0, _possibleConstructorReturn3.default)(this, (DyzioSearchBox.__proto__ || (0, _getPrototypeOf2.default)(DyzioSearchBox)).call(this, props));

    _this.onSearchActivate = function () {
      var onSearch = _this.props.onSearch;
      var _this$state = _this.state,
          searchTerm = _this$state.searchTerm,
          lastSubmittedSearch = _this$state.lastSubmittedSearch;

      if (lastSubmittedSearch !== searchTerm) {
        onSearch(_this.state.searchTerm);
        _this.setState({
          lastSubmittedSearch: searchTerm
        });
      }
    };

    _this.onSearchKeyPress = function (e) {
      if (e.key === 'Enter') {
        _this.onSearchActivate();
      }
    };

    _this.onSearchChange = function (e) {
      _this.setState({
        searchTerm: e.target.value
      });
    };

    _this.clear = function () {
      _this.setState({
        searchTerm: ''
      }, _this.onSearchActivate);
    };

    _this.searchTerm = '';
    _this.state = {
      searchTerm: '',
      lastSubmittedSearch: null
    };
    return _this;
  }

  (0, _createClass3.default)(DyzioSearchBox, [{
    key: 'render',
    value: function render() {
      var searchTerm = this.state.searchTerm;
      var _props = this.props,
          placeholderText = _props.placeholderText,
          isLoading = _props.isLoading;


      return _react2.default.createElement(
        _semanticUiReact.Input,
        {
          labelPosition: 'left',
          iconPosition: 'right',
          placeholder: placeholderText,
          onChange: this.onSearchChange,
          onKeyPress: this.onSearchKeyPress,
          onBlur: this.onSearchActivate,
          loading: isLoading,
          disabled: isLoading,
          value: searchTerm
        },
        _react2.default.createElement(
          _semanticUiReact.Label,
          null,
          _react2.default.createElement(_semanticUiReact.Icon, { name: 'search' })
        ),
        _react2.default.createElement('input', { style: { flex: 'auto' } }),
        searchTerm ? _react2.default.createElement(_semanticUiReact.Icon, { name: 'delete', link: true, onClick: this.clear }) : _react2.default.createElement(_semanticUiReact.Icon, null)
      );
    }
  }]);
  return DyzioSearchBox;
}(_react2.default.Component);

DyzioSearchBox.propTypes = {
  onSearch: _propTypes2.default.func.isRequired,
  placeholderText: _propTypes2.default.string.isRequired,
  isLoading: _propTypes2.default.boolean
};
DyzioSearchBox.defaultProps = {
  isLoading: false
};

exports.default = DyzioSearchBox;


/*****************
 ** WEBPACK FOOTER
 ** ./~/dyzio-shared-components/lib/components/dyzio-search-box/index.js
 ** module id = 2587
 ** module chunks = 0
 **/